import React, { useEffect, useState } from "react";
import { Modal, Button, Spinner } from "react-bootstrap";
import Markdown from "./Markdown";

const DescriptionEditorModal = ({ show, onHide, id, initialHtml = "", fetchDescription, onSave }) => {
  const [value, setValue] = useState("");
  const [text, setText] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (show) {
      setError("");
      if (fetchDescription && id != null) {
        setLoading(true);
        Promise.resolve(fetchDescription(id))
          .then((desc) => {
            setValue(desc || "");
            setText(desc || "");
          })
          .catch(() => {
            setError("Failed to load description");
            setValue(initialHtml || "");
            setText(initialHtml || "");
          })
          .finally(() => setLoading(false));
      } else {
        setValue(initialHtml || "");
        setText(initialHtml || "");
      }
    }
  }, [show, id, fetchDescription, initialHtml]);

  const handleSave = () => {
    if (onSave) {
      onSave(value, text, id);
    }
  };

  return (
    <Modal size="xl" show={show} onHide={onHide} animation={false}>
      <Modal.Header closeButton>
        <Modal.Title>Edit Description</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading ? (
          <div className="d-flex justify-content-center align-items-center" style={{ minHeight: 200 }}>
            <Spinner animation="border" />
          </div>
        ) : (
          <Markdown value={value} setValue={setValue} setText={setText} placeholder="Enter Description (5,000 Characters)" />
        )}
        {error && <div className="text-danger mt-2">{error}</div>}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
        <Button onClick={handleSave} disabled={!onSave}>
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DescriptionEditorModal;
